import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

// Store Cash Office at the counter — /api/v1/pos/cash_office/* (store and terminal come from the POS token).
// Every create sends a client_ref made when the form opens: a retried tap returns the first document (200).
export const cashOfficeApi = createApi({
  reducerPath: 'cashOfficeApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['CashOfficeSummary', 'CashOfficeTransfer'],
  endpoints: (builder) => ({

    // Boxes, expense heads, bank accounts, cash on its way here and what this cashier may do.
    getCashOfficeSummary: builder.query({
      query: () => '/cash_office/summary',
      providesTags: ['CashOfficeSummary'],
    }),

    // body: plain object, or FormData when a bill photo is attached (bills[]).
    createCashOfficeVoucher: builder.mutation({
      query: (body) => ({ url: '/cash_office/vouchers', method: 'POST', body }),
      invalidatesTags: ['CashOfficeSummary'],
    }),

    // Transfers touching this store; the panel shows the ones on their way here.
    getCashOfficeTransfers: builder.query({
      query: () => '/cash_office/transfers',
      providesTags: ['CashOfficeTransfer'],
    }),

    // Safe drop / cash to a petty box from the open session's drawer.
    sendCashOfficeTransfer: builder.mutation({
      query: (body) => ({ url: '/cash_office/transfers', method: 'POST', body }),
      invalidatesTags: ['CashOfficeSummary', 'CashOfficeTransfer'],
    }),

    receiveCashOfficeTransfer: builder.mutation({
      query: ({ id, counted_amount }) => ({ url: `/cash_office/transfers/${id}/receive`, method: 'POST', body: { counted_amount } }),
      invalidatesTags: ['CashOfficeSummary', 'CashOfficeTransfer'],
    }),

    // Top up a petty box of this store from the drawer (up to its float).
    createCashOfficeTopup: builder.mutation({
      query: (body) => ({ url: '/cash_office/topups', method: 'POST', body }),
      invalidatesTags: ['CashOfficeSummary', 'CashOfficeTransfer'],
    }),

    // Bank deposit straight from the drawer.
    createCashOfficeDeposit: builder.mutation({
      query: (body) => ({ url: '/cash_office/deposits', method: 'POST', body }),
      invalidatesTags: ['CashOfficeSummary'],
    }),
  }),
});

export const {
  useGetCashOfficeSummaryQuery,
  useCreateCashOfficeVoucherMutation,
  useGetCashOfficeTransfersQuery,
  useSendCashOfficeTransferMutation,
  useReceiveCashOfficeTransferMutation,
  useCreateCashOfficeTopupMutation,
  useCreateCashOfficeDepositMutation,
} = cashOfficeApi;
